"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Snippets = require("snippets");
var next_components_1 = require("@dotdev/next-components");
var WishlistPageTemplate = /** @class */ (function (_super) {
    __extends(WishlistPageTemplate, _super);
    function WishlistPageTemplate(props) {
        var _this_1 = _super.call(this, props) || this;
        _this_1.componentWillMount = function () {
            var _this = _this_1;
            if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push(function () {
                var __wishlistedProducts = [];
                _swat.fetch(function (products) {
                    products.forEach(function (product) {
                        var du = product.du;
                        fetch(du + ".json")
                            .then(function (response) { return response.json(); })
                            .then(function (data) {
                            data.id = product.id;
                            data.epi = product.epi;
                            data.empi = product.empi;
                            data.du = product.du;
                            __wishlistedProducts.push(data);
                            if (products.length == __wishlistedProducts.length) {
                                _this.setState({
                                    products: products.length ? __wishlistedProducts : [],
                                    isLoading: false
                                });
                            }
                        });
                    });
                }, _swat.EventTypes.addToWishlist);
            });
        };
        _this_1.state = {
            products: [],
            removingId: null,
            isLoading: true
        };
        return _this_1;
    }
    WishlistPageTemplate.prototype.removeProduct = function (product) {
        this.setState({ removingId: product.id });
        var _this = this;
        _swat.removeFromWishList({
            et: 4,
            epi: product.epi,
            empi: product.empi,
            du: product.du
        }, function success() {
            _this.setState({
                products: _this.state.products.filter(function (item) { return item.id !== product.id; }),
                removingId: null
            });
        });
    };
    WishlistPageTemplate.prototype.render = function () {
        var _this_1 = this;
        var lable = "text-sm text-primary font-medium tracking-wider";
        var page = this.props.data.page;
        var products = this.state.products;
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(Snippets.Container, { tag: "section", className: "flex flex-col md:flex-row items-center py-2-4 justify-center mlg:px-11 w-full max-w-xl" },
                React.createElement("div", { className: "hidden lg:block w-1/4" },
                    React.createElement(Snippets.Breadcrumbs, __assign({}, this.props))),
                React.createElement("div", { className: "w-full lg:w-1/2 text-center" }, page.title ? (React.createElement(Snippets.Heading, { size: "h4", tag: "h1", className: "font-bold leading-normal" }, page.title)) : null),
                React.createElement("div", { className: "hidden lg:block w-1/4" })),
            React.createElement(Snippets.Container, { tag: "section", className: "flex flex-col md:flex-row items-center py-2-4" },
                React.createElement("div", { id: "wishlist-items-container" }),
                React.createElement("div", { className: "w-full flex flex-wrap " + (products.length ? "" : "justify-center align-center") }, this.state.isLoading ? (React.createElement("h2", null, "Loading...")) : products.length ? (products.map(function (item, i) { return (React.createElement("div", { className: "block relative mb-0-8 md:mb-1-2 lg:mb-2-4 w-full md:w-1/2 lg:w-1/4" },
                    React.createElement("div", { className: "bg-arctic h-full px-0-4 flex flex-col justify-between min-h-33-6 md:min-h-42 mx-0-8 md:mx-1-2\n                  " + (_this_1.state.removingId == item.id && _this_1.state.removingId !== null ? "opacity-50" : "") },
                        React.createElement(Snippets.WishlistProduct, { key: i, product: item },
                            React.createElement("div", { className: "text-center pb-4" },
                                React.createElement("button", { className: "underline " + lable, onClick: function () { return _this_1.removeProduct(item); } }, "Remove From Wishlist")))))); })) : (React.createElement("a", { href: "/account" },
                    React.createElement("h2", { className: "text-center" }, "Your Wishlist is empty!")))))));
    };
    return WishlistPageTemplate;
}(React.Component));
exports.WishlistPageTemplate = WishlistPageTemplate;
WishlistPageTemplate.contextType = next_components_1.ShopifyNext.Context;
